import { LadsHostAppService } from '../host-app.service';
import { runOnLCGAppInit } from '../run-on-init.provider';
import { LDHostAppService } from './lazy-module.service';

export const provideLadsCoreBootstrap = () => runOnLCGAppInit(LadsHostAppService);
export const provideLDModuleBootstrap = () => runOnLCGAppInit(LDHostAppService);
